import React, { useState } from "react";
import { t } from "i18next";
import { StaffAccessTableData } from "../../../../../types/formDataTypes";
import { getPerfectDate } from "../../../../../helpers/utils";
import DeleteAccess from "./DeleteAccess";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "../../../../../ui/DataTable/DataTable";
import { Button } from "../../../../../ui/Button";
import { TbTrash } from "react-icons/tb";

type Props = {
  data: { nodes: StaffAccessTableData[] };
  equipmentId: string | undefined;
  updateList: Function;
};

const AccessesTable = ({ data, equipmentId, updateList }: Props) => {
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);
  let [currentItemId, setCurrentItemId] = useState("");

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
    setCurrentItemId("");
  }

  function onItemDelete(id: string): void {
    setCurrentItemId(id);
    openDeleteModal();
  }

  const columns: ColumnDef<StaffAccessTableData>[] = [
    {
      header: t("date"),
      cell: ({ row }) => <div>{getPerfectDate(row.original.at)}</div>,
    },
    {
      header: t("access_token"),
      cell: ({ row }) => <div>{row.original.access_token_id}</div>,
    },
    {
      header: t("access_token_type"),
      cell: ({ row }) => <div>{t(`${row.original.access_token_type}_access`)}</div>,
    },
    {
      header: t("status"),
      cell: ({ row }) => <div>{t("access_status_" + row.original.status)}</div>,
    },
    {
      id: "actions",
      header: "",
      cell: ({ row }) => (
        <div className="flex justify-end items-end">
          <Button
            type="button"
            size={"xs"}
            onClick={() => onItemDelete(row.original.id)}
            variant={"destructive"}
            className="flex items-center justify-center w-7 h-7 p-1"
          >
            <TbTrash />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <DeleteAccess
        tokenId={currentItemId}
        equipmentId={equipmentId}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
        updateList={updateList}
      />

      <DataTable data={data.nodes} columns={columns} />
    </div>
  );
};

export default AccessesTable;
